/**
 * Lemon Squeezy Checkout Overlay helpers (Lemon.js).
 * Does not unlock payment — App still uses verify/unlock after success.
 */

// Init Lemon.js for SPAs (safe to call more than once)
export const initLemonSqueezy = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  if (typeof window.createLemonSqueezy === 'function') {
    window.createLemonSqueezy();
  }
  return !!(window.LemonSqueezy && window.LemonSqueezy.Url);
};

/**
 * Register Checkout.Success (and related) handlers.
 * @param {(event: { event?: string, data?: unknown }) => void} eventHandler
 */
export const setupLemonCheckoutEvents = (eventHandler) => {
  if (typeof window === 'undefined') {
    return;
  }
  initLemonSqueezy();
  if (window.LemonSqueezy && typeof window.LemonSqueezy.Setup === 'function') {
    window.LemonSqueezy.Setup({ eventHandler });
  }
};

/**
 * Open Lemon checkout overlay; falls back to full-page redirect.
 * @returns {'overlay'|'redirect'}
 */
export const openLemonCheckout = (checkoutUrl) => {
  if (!checkoutUrl) {
    throw new Error('Missing checkout URL');
  }
  initLemonSqueezy();
  if (
    window.LemonSqueezy &&
    window.LemonSqueezy.Url &&
    typeof window.LemonSqueezy.Url.Open === 'function'
  ) {
    window.LemonSqueezy.Url.Open(checkoutUrl);
    return 'overlay';
  }
  window.location.href = checkoutUrl;
  return 'redirect';
};

export default {
  initLemonSqueezy,
  setupLemonCheckoutEvents,
  openLemonCheckout,
};
